<template>
  <div class="body">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
      href="https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@700&family=Lexend&display=swap"
      rel="stylesheet"
    />
    <Card :cars="cars" />
  </div>
</template>

<script>
import Card from '../components/component-preview-columns/index.vue';

export default {
  name: 'ColumnPreviewComponents',
  components: {
    Card,
  },
  data() {
    return {
      cars: [
        {
          title: 'sedans',
          text: `Choose a sedan for its affordability and excellent fuel economy.
                Ideal for cruising in the city or on your next road trip.`,
          img_url: 'icon-sedans.svg',
          className: ['card--sedan', 'button--sedan'],
        },
        {
          title: 'suvs',
          text: `Take an SUV for its spacious interior, power, and versatility.
                 Perfect for your next family vacation and off-road adventures.`,
          img_url: 'icon-suvs.svg',
          className: ['card--suv', 'button--suv'],
        },
        {
          title: 'luxury',
          text: `Cruise in the best car brands without the bloated prices.
                  Enjoy the enhanced comfort of a luxury rental and arrive in style.`,
          img_url: 'icon-luxury.svg',
          className: ['card--luxury', 'button--luxury'],
        },
      ],
    };
  },
};
</script>

<syyle src="../css/components-preview/global.css" scoped />
<style lang="scss" scoped>
  .body {
      --bright-orange: hsl(31, 77%, 52%);
      --dark-cyan: hsl(184, 100%, 22%);
      --very-dark-cyan: hsl(179, 100%, 13%);
      --transparent-bg: hsla(0, 0%, 100%, 0.75);
      --very-light-gray: hsl(0, 0%, 95%);
      --transparent-btn-bg: hsla(0, 0%, 100%, 1);

      --border-radius: 0.5rem;

      --ff-default: "Lexend", sans-serif;
      --ff-alt: "Big Shoulders Display", cursive;
      --fs-base: 0.9375rem;

      /* fonts */
      --fs-h0: 6rem;
      --fs-h1: 3rem;
      --fs-h2: 2rem;
      --fs-h3: 1.3rem;
      --fs-h4: 1rem;
      --fw-100: 100;
      --fw-normal: 400;
      --fw-600: 600;
      --fw-700: 700;
      --fw-900: 900;

      /* spacing */
      --sm-spacer: 1.5rem;
      --bg-spacer: 3rem;

      font-size: var(--fs-base);
      font-family: var(--ff-default);
      background-color: var(--transparent-bg);

      min-height: 100vh;
      display: grid;
      place-items: center;

    }
</style>
